
import { Toast, PullRefresh, SwipeCell, Dialog, Badge, Field } from "vant";
Vue.use(Badge);
import { Component, Vue } from "vue-property-decorator";
import {
  extractInfo,
  extractApply,
  getUserSign,
  userSignFace,
} from "@/req/pay";
import { getUserInfo } from "@/req/user";
import httpApi from "@/apis/httpApi";
import Extract from "./components/index.vue";
import FaceSignPopup from "../newExtract/modal/faceSignPopup.vue";
import tradeCoinText from "./components/index.js";
@Component({
  components: { PullRefresh, SwipeCell, Badge, Extract, FaceSignPopup },
})
export default class Logout extends Vue {
  public isLoading = false;
  public extractShow = false;
  public confirmShow = false;
  public clause = true;
  public alipayAccount = "";
  public money: any = "";
  public canExtract = 0;
  public url = this.$HTTP_API.user.tradeCoin;
  public infoList: any = {
    minExtractMoney: null, // 最低提现金额
    minExtarctRatio: null, // 手续费比例
    minExtarctCharge: null, // 最低提现手续费
    canExtract: null, // 可提现金币
    entryCmoney: null, // 待入账
    explain: "", // 小问号提示语
    isRead: null,
    is_no_audit: null, // 是否有未成功订单
    coupon_can_use_money: 0, // 券可抵扣金额，为0 则无抵扣 单位 元
    normal_explain: "",
    svip_value_use_limit_pct: "", // svip 抵扣上限 （百分比）
    trade_coin: 0,
    gold_tips: "",
    later_expire_30_gold: "",
  };
  public extractData: any = {};
  public type: any = 2;
  public goldSign = false;
  public svipClause = false;
  public faceSignPopup = false;
  public faceSignUrl = "";
  public mounted() {
    (window as any).extractPage = this; // window变量绑定this
    const obj: any = this.$fn.parseQuery(window.location.href);
    if (obj.token) {
      this.$fn.cookies.removeToken();
      this.$fn.cookies.setToken(obj.token);
      this.$fn.cookies.setShowNav(1);
    }
    if (obj.type) {
      sessionStorage.setItem("extractType", obj.type);
    } else if (this.$route.params.type) {
      sessionStorage.setItem("extractType", this.$route.params.type);
    }
    // if (this.$route.query.type) {
    //   const types: any = this.$route.query.type;
    //   sessionStorage.setItem("extractType", types);
    // }
    this.type = sessionStorage.getItem("extractType");
    if (this.type == 1) this.getUserSign();
    if (this.type == 2) {
      this.goldSign = true;
      this.clause = true;
    }
    this.getExtractType();
    this.getTradeCoin();
    const $extract = this.$refs.extract as any;
    $extract.style.height = $extract.offsetHeight + "px";
    this.extractData = {
      type: this.type,
      infoList: this.infoList,
    };
  }
  // 返回手续费
  public returnMinMoney(money) {
    let sxfMoney: any = (money * this.infoList.minExtarctRatio) / 100;
    sxfMoney =
      sxfMoney < this.infoList.minExtarctCharge
        ? this.infoList.minExtarctCharge
        : sxfMoney;
    return sxfMoney;
  }
  // 获取交易币说明
  public async getTradeCoin() {
    const res = await tradeCoinText(this.url);
    this.infoList.explain = res.data;
  }
  // 获取提现配置
  public async getExtractType() {
    const obj: any = {
      type: this.type,
      need_extract_info: 1,
      need_read_status: 1,
      need_no_audit: 1,
      extract_type: 1,
    };
    const res = await extractInfo(obj);
    if (res.code == 200) {
      const data = res.data;
      this.infoList.minExtractMoney = data.min_extract_money;
      this.infoList.minExtarctRatio = data.min_extarct_ratio;
      this.infoList.minExtarctCharge = data.min_extarct_charge;
      this.infoList.entryCmoney = data.extract_info ? data.extract_info : 0;
      this.infoList.isRead = data.is_read;
      this.infoList.is_no_audit = data.is_no_audit;
      this.infoList.coupon_can_use_money = data.coupon_can_use_money;
      this.infoList.svip_value_use_limit_pct = data.svip_value_use_limit_pct;
      this.infoList.gold_tips = data.gold_tips;
      this.infoList.normal_explain = data.normal_explain;
      this.infoList.later_expire_30_gold = data.later_expire_30_gold;
    } else {
      Toast(res.msg);
    }
  }
  // 申请提现
  public async onExtractDialog() {
    const obj = {
      type: Number(this.type),
      money: this.money,
      alipay_account: this.alipayAccount,
      extract_type: 1,
      user_coupon: !this.svipClause ? 0 : 1,
    };
    // 二次密码验证
    if (this.$fn.gitIsVersion(400)) {
      const url = httpApi.pay.extractApply;
      (window as any).jsSendIosWithdrawalVerification({
        url,
        type: "post",
        json: obj,
      });
      return;
    }
    const res = await extractApply(obj);
    this.extractResult(res);
  }
  public extractResult(res) {
    if (res.code == 200) {
      this.$store.state.user.info.trade_coin =
        this.$store.state.user.info.trade_coin - this.money;
      this.extractShow = false;
      this.confirmShow = true;
      const refExtract = this.$refs.refExtract as any;
      refExtract.onReset();
      this.getExtractType();
      (window as any).sendEditorTrackEvent(
        res.data.extarct_charge_money,
        res.data.order_id,
      );
    } else if (res.code == "20039") {
      this.$dialog
        .alert({
          message: "账号未实名认证，请先进行实名认证",
          showCancelButton: false,
          confirmButtonColor: "#000",
        })
        .then(async () => {
          this.$router.push({ name: "verificationCode" });
        })
        .catch(() => {
          // on cancel
        });
    } else {
      this.extractShow = false;
      Toast(res.msg);
    }
  }
  // Dialog
  public modalShow(obj) {
    if (obj.id == 1) {
      this.money = obj.money;
      this.extractShow = true;
      this.alipayAccount = obj.account;
      this.svipClause = obj.svipClause;
    }
  }
  // 提现记录
  public onClickRight() {
    this.$router.push({ name: "extractRecord", params: { type: this.type } });
  }
  public onClickLeft() {
    this.confirmShow = false;
  }
  public onRefresh() {
    setTimeout(() => {
      this.getExtractType();
      Toast("刷新成功");
      this.isLoading = false;
    }, 1000);
  }
  // 金币提现签约查询接口
  public async getUserSign() {
    const res = await getUserSign();
    if (res.code == 200) {
      this.goldSign = res.data;
    }
  }
  // 人脸签约校验（金币提现）
  public async checkFaceSign() {
    const userInfo = this.$store.state.user.info || {};

    const gfs = userInfo.gold_face_sign;
    // 已签约（明确为 1）
    if (Number(gfs) === 1) return true;
    // gold_face_sign 未获取到：undefined / null / ''，默认需要走签约校验
    const faceRes = await userSignFace({
      uid: Number(userInfo.id),
    });
    if (faceRes.code !== 200) {
      Toast(faceRes.msg || "人脸签约失败");
      return false;
    }
    const faceData = faceRes.data || {};
    const signed =
      faceData.is_signed === true
        ? true
        : faceData.is_signed === false
        ? false
        : null;
    // is_signed 未返回时，默认需要签约
    if (signed !== true) {
      if (faceData.sign_url) {
        this.faceSignUrl = faceData.sign_url;
        this.faceSignPopup = true;
      } else {
        Toast(faceData.tips || "未获取到人脸签约链接");
      }
      return false;
    }
    const info = this.$store.state.user.info;
    if (info) this.$set(info, "gold_face_sign", 1);
    return true;
  }
  public onCancelFaceSign() {
    this.faceSignPopup = false;
    this.faceSignUrl = "";
  }
  public onConfirmFaceSign() {
    const url = this.faceSignUrl;
    this.faceSignPopup = false;
    this.faceSignUrl = "";
    if (url) window.location.href = url;
  }
  // 实际到账金额校验
  public efficacyNum(num) {
    this.money = num;
    const commission: any = this.getServiceCharge();
    const accountNum: any = this.getNum(num - commission);
    if (accountNum > 0) {
      const refExtract = this.$refs.refExtract as any;
      refExtract.secondEfficacy();
    } else {
      Toast("实际到账金额小于或等于0元");
    }
  }
  public getNum(num) {
    if (typeof num == "number") {
      // 判断是否为数字类型   数字类型自动  舍0
      num = num.toString(); // 先转成  字符串类型
      if (num.indexOf(".") != -1) {
        // 判断 有无小数点  0 表示 有小数点  -1  表示没有小数点
        let b = num.split("."); // 根据小数点  转换字符串为数组
        if (b[1].length == 1) {
          // 判断 有几位小数  如果有一位  加一个0
          b = b.join(".");
          b += "0";
          num = b;
        }
      } else {
        num += ".00";
      }
    } else if (typeof num == "string") {
      // 同理
      if (num.indexOf(".") != -1) {
        let b: any = num.split(".");
        if (b[1].length == 1) {
          b = b.join(".");
          b += "0";
          num = b;
        }
      } else {
        num += ".00";
      }
    }
    return num;
  }
  public getServiceCharge() {
    // 得出提现所付手续费
    let num =
      (this.money * this.infoList.minExtarctRatio) / 100
        ? (this.money * this.infoList.minExtarctRatio) / 100
        : 0;
    const minNum = parseInt(this.infoList.minExtarctCharge, 0);
    num = num > minNum ? num : minNum;
    if (this.svipClause) {
      // 得出减免后的 提现所付手续费
      let limitPct = (num * this.infoList.svip_value_use_limit_pct) / 100;
      num = num - limitPct;
      limitPct =
        limitPct - this.infoList.coupon_can_use_money > 0
          ? limitPct - this.infoList.coupon_can_use_money
          : 0;
      num = num + limitPct;
    }
    return num ? num.toFixed(2) : 0;
  }
}
